// extracted by mini-css-extract-plugin
module.exports = {"moduleWrapper":"DemoSidebar_moduleWrapper__1nIT7","wrapper":"DemoSidebar_wrapper__e42SZ"};